import { render, staticRenderFns } from "./kpsrStatus.vue?vue&type=template&id=071e053c"
import script from "./kpsrStatus.vue?vue&type=script&lang=js"
export * from "./kpsrStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071e053c')) {
      api.createRecord('071e053c', component.options)
    } else {
      api.reload('071e053c', component.options)
    }
    module.hot.accept("./kpsrStatus.vue?vue&type=template&id=071e053c", function () {
      api.rerender('071e053c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/kpsrStatus.vue"
export default component.exports